import { FormatOptions } from "./Format";
// import ptSans from "./PTSans-Bold.woff";
// Simple format options interface to avoid heavy dependencies

const x = 1 / 12;
// Structure atom-label font (MC-946). Leads with the "PTSans-Bold" family — registered
// by @alchemiesolns/shared-styles/fonts — and ENDS in a generic so an SVG <text> can
// never fall back to the browser serif default (Times New Roman) if the woff fails to
// load. Matches the fallback chain apps/reaction-schemes-generator already uses.
const ptSans = "PTSans-Bold, DejaVu Sans, Liberation Sans, Helvetica Neue, Helvetica, Arial, sans-serif";

export const lineAngleFormat: FormatOptions = {
    fontFamily: ptSans,
    fontSize: 33 * x,
    zoom: {
        default: 12.4,
        max: 27.6,
        min: 5.6,
    },
    atom: {
        radius: (33 * x) / 2,
        symbolOffset: [0, 0.1, 5],
        carbon: {
            scale: 0.18,
            scaleBig: (12 * x) / 2,
        },
    },
    lonePair: {
        radius: (8 / 2) * x,
        offset: 25 * x,
        carbonOffset: 25 * x,
        hover: {
            offset: 1.2,
            scale: 1.3,
        },
        ratios: {
            offset: 23 * x,
            gap: 14.5 * x,
        },
    },
    charge: {
        radius: 24 * x / 2,
        offset: [25 * x, 25 * x],
        carbonOffset: [18 * x, 18 * x],
        outlineScale: 1.75 * x,
        multiFont: 15 * x,
        fontFamily: ptSans,
        outlineMultiScale: 1.4,
        multiRadius: 2,
        minus: {
            fontSize: 28 * x,
            offsetY: 0,
        },
        plus: {
            fontSize: 32 * x,
            offsetY: 0,
        },
        symbol: {
            length: 14 * x,
            width: 20 * x,
        },
    },
    bond: {
        length: 90 * x,
        offset: 11 * x,
        highlightScale: [3, 1, 3],
        scale: [1.5, 1, 1.5],
        thickness: 6 * x,
        hitBox: 2,
        wedgeHeight: 15 * x,
        ratios: {
            single: {
                carbonToCarbon: 1,
                carbonToNonCarbon: 7 / 9,
                nonCarbonToNonCarbon: 5 / 9,
            },
            double: {
                carbonToCarbon: {
                    centered: 19 / 18,
                    offset: 7 / 9,
                },
                carbonToNonCarbon: {
                    centered: 7 / 9,
                    offset: 7 / 9,
                },
                nonCarbonToNonCarbon: 5 / 9,
                carbonToNonCarbonRing: 2 / 3,
                carbonToCarbonFiveRing: 4 / 5,
            },
            triple: {
                carbonToCarbon: 1,
                carbonToNonCarbon: 7 / 9,
                nonCarbonToNonCarbon: 5 / 9,
            },
        },
    },
    symbol: {
        height: 2.5,
    },
    arrow: {
        thickness: 6 * x,
    },
};